import React from 'react';

export default ({ links = [] }) => {
    let total = links.length;
    return (
        <ol className="breadcrumb">
            <li>
                <a href="/">Inicio</a>
            </li>
            {
                links.map( (link,index) => {
                    if (index !== total - 1) {
                        return (
                            <li key={"breadcrumb" + index}>
                                <a href={link.url}>{link.text}</a>
                            </li>
                        );
                    }
                    return <li key={"breadcrumb" + index} className="active">{link.text}</li>
                })
            }
        </ol>
    );
}


// WEBPACK FOOTER //
// ./src/components/Breadcrumbs.js